import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {  useSelector } from "react-redux";

const Recentlyowl = ({Data,catid,catpage}) => {
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [activecls,setactivecls] = useState("")


const nvg = useNavigate()

  const transfer = (productid)=>{
    nvg("/productdetails",{ state: { id: productid,categoryid:catid,pagename:catpage,pname:Data?.title} });
    // window.location.reload();
  }

  return (
    <div
    onMouseEnter={()=>{setactivecls(Data?.id)}}
    onMouseLeave={()=>{setactivecls("")} }
    >
      <div className=" mx-2 my-2 catbox">
    <div className="product-box p-0 " onClick={()=>{transfer(Data?.id)}}
        >
      <div className="product-imgbox" style={{position: "relative", overflow: "hidden" }}  >

      {Data?.stock_qty <= 0 && (
        <div className="overlay" onClick={() => {transfer(Data?.id, Data?.title)}} 
                                            >

                                            </div>)}

                                        {Data?.stock_qty <= 0 && (
                                          <div className="out-of-stock" style={{ backgroundColor: `#${bgColor}`}}
>Out of Stock</div>
                                        )}


        <div className="product-front" style={{ position: "relative",}}>
        {/* <span
          style={{
            position: "absolute",
            width : "fit-content",
            // top:item?.stock?.discount == 0 ? '' : '34px',
            fontSize: "12px",
            color: "#fff",
            backgroundColor: "#0cb744",
            padding: "2px 6px",
            borderRadius: "4px",
            fontWeight: "600",
          }}
        >
          {`${Data?.stock_qty} pcs Available`}
        </span> */}



        
        {/* {Data?.stock_discount != 0 && (
      <>
        <span
          style={{
            position: "absolute",
            width : "100px",

            fontSize: "12px",
            color: "#fff",
            backgroundColor: "#ff5722",
            padding: "2px 6px",
            borderRadius: "4px",
            fontWeight: "600",
          }}
        >
          
          {Data?.discount_type === "amount"
            ? `₹${Data?.stock_discount} OFF`
            : `${Data?.stock_discount}% OFF`}
        </span>
      </>
    )} */}
        <button type='button' className='btn fixedhight' style={{width:'100%'}} onClick={()=>{transfer(Data?.id)}}>
            <img src={`${process.env.REACT_APP_API_URL}media/${Data?.image}`} className="img-fluid  " alt="product" />

          </button>
          
        </div>
  
        
        {/* <div className="product-back">
          <a href="/home">
            <img src="./images/layout-2/product/a1.jpg" className="img-fluid  " alt="product" />
          </a>
        </div> */}
       
      </div>
      <div className="product-detail detail-inline ">
      {activecls === Data?.id && (
    <span
      style={{
        position: "absolute",
        top: `${300 
          - (Data?.title.length > 60 ? 20 : 0) 
          - (Data?.title.length > 120 ? 20 : 0)}px`,
        left: "50%",
        transform: "translateX(-50%)", // Center horizontally
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fontSize: "10px",
        fontWeight: "400",
        textAlign: "center",
        borderRadius: "5px",
        padding: "6px 10px",
        zIndex: 9999, // Ensure it's on top of everything
        width: "max-content",
        maxWidth: "250px",
        whiteSpace: "normal",
        wordWrap: "break-word",
        opacity: 1,
        transition: "opacity 0.2s ease-in-out",
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
      }}
    >
      {`${Data?.att?.find(attr => attr?.code?.toLowerCase() === "brand")?.value || "N/A"}: ${Data?.title}`}
    </span>
)}
   
         <div className="detail-title">
                                        <div className="detail-left" style={{width:'100%'}}>
                                          <div
                                            style={{
                                              
                                              display: "flex",
                                              // justifyContent: "center",
                                              flexDirection:'column',
                                              // alignItems:'center',
                                              position: "relative", 

                                            }}
                                          >
                                            {" "}
                                            {/* <button
                                              type="button"
                                              className="btn"
                                              onClick={() => {
                                                transfer(item.id);
                                              }}
                                            > */}
                  <h6
  className="price-title catbox2"
  style={{
    // color: colorState.current && colorState.current[1] === Data?.[0]?.id ? "#808080" : "black",
    color: activecls === Data?.[0]?.id ? "#808080" : "black",
    fontSize: "14px",
    fontWeight: "100",
    height: "40px",
    lineHeight: "20px",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    textAlign: "center",
    cursor: "pointer",
    position: "relative",
  }}
>
  

  
  <span style={{color:'green'}}>{`${Data?.att?.find(attr => attr?.code?.toLowerCase() === "brand")?.value || "N/A"}:`}</span>
  {`${Data?.title}`}
  

</h6>


                                            {/* </button> */}
                                          </div>
                                        </div>
                                        <div
                                          className="detail-right"
                                          style={{ width: "100%" }}
                                        >
                                          <div
                                            className="price"
                                            style={{ width: "100%" }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                color: "#000",
                                                fontSize: "14px",
                                              }}
                                            >
                            
                                             
                                             {new Intl.NumberFormat("en-IN", {style: "currency",currency: "INR",minimumFractionDigits: 0,maximumFractionDigits: 0,}).format(parseInt(Data?.stock_price))}
                                              {Data?.stock_discount == 0 ? '' : <span style={{fontSize: '13px',color: '#616660',lineHeight: '20px',textDecoration: 'line-through',paddingLeft:'3px',fontWeight:'400'}}> {new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0, 
  maximumFractionDigits: 0, 
}).format(parseInt(Data?.stock_mrp))}
                                                </span>}{Data?.stock_discount == 0 ? '' : <span style={{fontSize: '12px',color: 'red',lineHeight: '20px',paddingLeft:'3px',fontWeight:'400'}}>({`${Data?.discount_type === "amount"
            ? `₹${Data?.stock_discount} OFF`
            : `${Data?.stock_discount}% OFF`}`})</span>}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
      </div>
    </div>
    </div>
  </div>
  )
}

export default Recentlyowl